import React, { useContext, useEffect, useRef, useState } from "react";
import { RecadastramentoContext } from "@contexts";
import { DependenteEntidade, WebRecadDadosConclusaoEntidade, WebRecadParticipanteDadosEntidade } from "@entidades";
import { RecadastramentoService } from "@services";
import { Alert, Box, Button, ButtonSwitch, Col, Input, Row, StaticField } from "@intech/web-ui";
import { LoadingComponent } from "@components";
import { FaAngleDoubleLeft, FaCheck } from "react-icons/fa";
import { StringIsNullOrEmpty } from "@helpers";
import { DMN_ORIGEM_SISTEMA } from "@domains";
import { Alteracoes } from "./Alteracoes";

interface IProps {
  voltar: (PassoEspecifico?: number | null) => Promise<void>;
  reiniciar: () => Promise<void>;
}

export const Passo10: React.FC<IProps> = ({
  voltar,
  reiniciar
}) => {
  const context = useContext(RecadastramentoContext);
  const isMountedRef = useRef(true);

  const [DadosFinais, setDadosFinais] = useState<WebRecadParticipanteDadosEntidade>(null);
  const [DadosOriginais, setDadosOriginais] = useState<WebRecadParticipanteDadosEntidade>(null);
  const [ListaDependentes, setListaDependentes] = useState<DependenteEntidade[]>([]);

  const [MetodoEnvioToken, setMetodoEnvioToken] = useState<boolean>(true);
  const [EmailToken, setEmailToken] = useState<string>("");
  const [CelularToken, setCelularToken] = useState<string>("");
  // const [BotaoTokenTitulo, setBotaoTokenTitulo] = useState<string>("Enviar Código de Validação");
  // const [TokenDigitado, setTokenDigitado] = useState<string>("");
  // const [TokenGerado, setTokenGerado] = useState<string>("");
  const [StatusRecad, setStatusRecad] = useState<string>("");
  const [AceitaTermos, setAceitaTermos] = useState<boolean>(false);

  const [Loading, setLoading] = useState<boolean>(true);
  const [ErroForm, setErroForm] = useState<string>("");
  const [Erro, setErro] = useState<string>("");

  useEffect(() => () => { isMountedRef.current = false }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        if (!isMountedRef.current)
          return;

        const dadosFinais = await context.buscarDadosParticipante();
        const dadosOriginais = await context.buscarDadosOriginais();
        const listaDependentes = await context.buscarListaDependentes();

        setDadosFinais(dadosFinais);
        setDadosOriginais(dadosOriginais);
        setCelularToken(dadosOriginais.FONE_CELULAR);
        setEmailToken(dadosOriginais.EMAIL_AUX);
        setListaDependentes(listaDependentes);
      } catch (e) {
        const error: any = e;
        const messsage = error.response ? error.response.data : error;
        setErro(messsage);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // async function EnviarToken() {
  //   setErroForm("");
  //   try {
  //     if (!AceitaTermos) {
  //       return setErroForm(
  //         "É necessario manifestar ciência e plena concordância com as informações aqui registradas para prosseguir com o recadastramento."
  //       );
  //     }

  //     const alvoEnvio = MetodoEnvioToken ? CelularToken : EmailToken;

  //     const token = await RecadastramentoService.EnviarToken(MetodoEnvioToken, !MetodoEnvioToken, alvoEnvio);

  //     setTokenGerado(token);
  //     setBotaoTokenTitulo("caso não receba o código pelo meio selecionado, clique aqui para reenviar");
  //     window.alert("CÓDIGO ENVIADO!\nMantenha esta página aberta até a inserção do código.\nAtenção: Ao fechar a tela, o código expira.");
  //   }
  //   catch (err) {
  //     setErroForm(err["response"] ? err["response"]["data"] : err);
  //   }
  // }

  async function handleVoltar() {
    setErroForm("");
    try {
      voltar();
    }
    catch (e) {
      const error: any = e;
      const messsage = error.response ? error.response.data : error;
      setErroForm(messsage);
    }
  }

  async function Concluir() {
    setErroForm("");
    try {
      if (!AceitaTermos) {
        return setErroForm("É necessario manifestar ciência e plena concordância com as informações aqui registradas para prosseguir com o recadastramento.");
      }

      // if (TokenGerado === "") {
      //   return setErroForm("É necessario realizar o envio do código para concluir o Recadastramento.");
      // }

      const recad = await context.buscarDadosRecadastramento();
      const listaArquivos = await context.buscarListaArquivo();

      const DadosConclusao = new WebRecadDadosConclusaoEntidade();
      DadosConclusao.Participante = DadosFinais;
      DadosConclusao.ListaArquivo = listaArquivos.map(a => a.TXT_NOME_FISICO);
      DadosConclusao.ListaDependentes = ListaDependentes.filter(d => !StringIsNullOrEmpty(d.IND_OPERACAO));
      DadosConclusao.CPF_Original = DadosOriginais.CPF_CGC;
      // DadosConclusao.TOKEN_DIGITADO = TokenDigitado;
      // DadosConclusao.TOKEN_ENVIADO = TokenGerado;
      DadosConclusao.OID_RECAD_PUBLICO_ALVO_Original = recad.OID_RECAD_PUBLICO_ALVO;
      DadosConclusao.Origem = DMN_ORIGEM_SISTEMA.PORTAL;

      const StatusRecad = await RecadastramentoService.Concluir(DadosConclusao);

      const AlertText = StatusRecad.replace("<b>", "").replace("</b>", "").replace("<br/>", "\n").replace("<br/>", "\n").split("<hr/>")[0];

      window.alert(AlertText);

      setStatusRecad(StatusRecad);

      reiniciar();
    }
    catch (err) {
      setErroForm(err["response"] ? (err["response"]["data"]["text"] || err["response"]["data"]) : err);
    }
  }

  return (
    <>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type={'danger'}>{Erro}</Alert>}

      {!Loading && !Erro && (
        <>
          <br />

          <span>{"As informações a seguir foram alteradas por você e serão efetivadas no seu cadastro na Faelce"}</span>

          <br />

          <br />

          <br />

          <Alteracoes />

          <Row>
            <Col>
              <Alert type={"info"}>{"clique no campo abaixo para confirmar as informações fornecidas para fins de recadastramento."}</Alert>
            </Col>
          </Row>

          <Box>
            {StatusRecad === "" && <>
              <div className={`alert alert-${(AceitaTermos ? "success" : "warning")}`}>
                <Row className={"mb-2"}>
                  <Col className={"col-lg-1 align-self-center"}>
                    <ButtonSwitch
                      activeType={"success"}
                      inactiveType={"light"}
                      inactiveIcon={" "}
                      checked={AceitaTermos}
                      onChange={() => setAceitaTermos(!AceitaTermos)}
                    />
                  </Col>

                  <Col className={"align-self-center"}>
                    {"Manifesto ciência e plena concordância com as informações aqui registradas, atestando a veracidade das mesmas."}
                  </Col>
                </Row>
              </div>

              <div className={"alert alert-warning"}>
                {"Para concluir o seu recadastramento, enviaremos um "}
                <b>{"código"}</b>
                {" de validação para o seu E-mail cadastrado na Faelce. Caso não tenha E-mail cadastrado ou não receba o código de validação, favor entrar em contato conosco em nossos canais de atendimento."}
              </div>

              {/* <Box title={"Código de Validação"}>
                <Row className={"mb-2"}>
                  <Col className={"col-lg-7 align-self-center"}>
                    <ButtonSwitch
                      activeType={"success"}
                      inactiveType={"light"}
                      inactiveIcon={" "}
                      activeTitle={"Enviar Código de Validação para o celular:"}
                      inactiveTitle={"Enviar Código de Validação para o celular:"}
                      checked={MetodoEnvioToken}
                      onChange={() => setMetodoEnvioToken(!MetodoEnvioToken)}
                    />
                  </Col>

                  <Col className={"align-self-center"}>
                    <StaticField
                      value={CelularToken}
                    />
                  </Col>
                </Row>

                <Row className={"mb-2"}>
                  <Col className={"col-lg-7 align-self-center"}>
                    <ButtonSwitch
                      activeType={"success"}
                      inactiveType={"light"}
                      inactiveIcon={" "}
                      activeTitle={"Enviar Código de Validação para o e-mail:"}
                      inactiveTitle={"Enviar Código de Validação para o e-mail:"}
                      checked={!MetodoEnvioToken}
                      onChange={() => setMetodoEnvioToken(!MetodoEnvioToken)}
                    />
                  </Col>

                  <Col className={"align-self-center"}>
                    <StaticField
                      value={EmailToken}
                    />
                  </Col>
                </Row>

                <Button
                  className={"mb-3"}
                  onClick={EnviarToken}
                  title={BotaoTokenTitulo}
                  type={"primary"}
                  disabled={!AceitaTermos}
                  usesLoading
                  loadingText={"Enviando..."}
                />

                <Input
                  title={"Digite aqui o Código de Validação recebido via E-mail"}
                  labelSize={4}
                  value={TokenDigitado}
                  onChange={setTokenDigitado}
                  inline
                />
              </Box> */}

              <Alert type={"danger"}>{ErroForm}</Alert>

              <Row>
                <Col>
                  <Button
                    type={"secondary"}
                    title={"Voltar"}
                    icon={<FaAngleDoubleLeft />}
                    onClick={handleVoltar}
                    loadingText={"Voltando..."}
                    usesLoading
                    block
                    iconRight
                  />
                </Col>

                <Col>
                  <Button
                    type={"primary"}
                    title={"Concluir Recadastramento"}
                    icon={<FaCheck />}
                    onClick={Concluir}
                    loadingText={"Concluindo..."}
                    usesLoading
                    block
                  />
                </Col>
              </Row>
            </>}

            {StatusRecad !== "" && <div
              className="alert alert-info"
              dangerouslySetInnerHTML={{
                __html: StatusRecad,
              }}
            ></div>}
          </Box>
        </>)}
    </>
  );
}
